import PropTypes from "prop-types";
import React from "react";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import { H2 } from "BaseComponents/Text";
import {
  PagePuffWrapper,
  PagePuffText,
  PagePuffContainer,
  PagePuffOuterWrapper,
} from "../PagePuff/components";
// import MapBlocksToComponents from "Helpers/BlockHelper";
import LazyBackgroundImage from "../../framework/lazy/LazyBackgroundImage";
import { HeaderLink } from "BaseComponents/Link";
import { RTEWrapper } from "BaseComponents/Wrappers";
import styled from "styled-components";
import { GetTextColor } from "Helpers/ColorHelper";

import { Video, VideoWrapper } from "Components/Video";
import {
  COLUMNELEMENT,
  CONTACTFORM,
  MEDIAITEM,
  TEXTITEM,
} from "Consts/blockTypes";
import { ColumnBlock, ContactForm } from "Blocks";

export const TwoColumnBlock = ({ BackgroundColor, Items }) => {
  const { textColor } = GetTextColor(BackgroundColor);
  return (
    <PagePuffOuterWrapper bgColor={BackgroundColor} className="twoColumnBlock">
      <PagePuffContainer className="page-puff">
        <PagePuffWrapper
          smallwidth="auto"
          padding="3rem 1rem"
          margin="0 auto"
          alignItems={
            Items.some((item) => item.Alias === "mediaItem")
              ? "center"
              : "flex-start"
          }
          justifycontent="space-between"
          flexdir={"row"}
          autoWidth={true}
          className={`twoColumnBlockPagePuffWrapper ${Items.some((item) => item.Alias === "contactForm")
              ? "contactFormWrapper"
              : ""}`}
          rowGap="45px"
        >
          {Items.map((item, key) =>
            GetBlock(item, key, textColor, BackgroundColor)
          )}
        </PagePuffWrapper>
      </PagePuffContainer>
    </PagePuffOuterWrapper>
  );
};

let GetBlock = (model, i, textColor, backgroundColor) => {
  const { Alias } = model;
  switch (Alias) {
    case COLUMNELEMENT:
      return (
        <ColumnBlock
          {...model}
          key={`block-${i}`}
          BackgroundColor={backgroundColor}
        />
      );
    case CONTACTFORM:
      return <ContactForm {...model} key={`block-${i}`} />;
    case MEDIAITEM:
      return <ImageItem {...model} key={`block-${i}`} />;
    case TEXTITEM:
      return <TextItem {...model} key={`block-${i}`} color={textColor} />;
    default:
      break;
  }
};

const VideoContainer = styled.div`
  margin: ${({ margin }) => (margin ? margin : "")};
  ${VideoWrapper} {
    width: 100%;
  }
  width: 100%;
  height: 100%;
  ${media.lessThan(breakpoints.mobile)`
	height: 200px;


button {
    height: 40px;
    width: 40px;
    i{
        font-size: 30px;
    }
}
    h1{
        margin-left: 20px;
        font-size: 16px;
        line-height: 24px;

    }
`};
`;

const ImageItem = ({ Image, VideoType, VideoLink }) => {
  return (
    <PagePuffWrapper
      justifycontent="center"
      padding="0"
      alignItems="center"
      smallpadding="0"
      flex="1 43.5%"
      flexgrow="0"
    >
      {Image &&
        (VideoLink ? (
          <VideoContainer>
            <Video Image={Image} VideoType={VideoType} VideoLink={VideoLink} />
          </VideoContainer>
        ) : (
          <LazyBackgroundImage maxHeight="303px" source={Image} />
        ))}
    </PagePuffWrapper>
  );
};

const TextItem = ({ Heading, Link, Preamble, color }) => {
  return (
    <PagePuffWrapper
      justifycontent="center"
      column={true}
      padding={"1.5rem 0rem 0 0rem"}
      smallpadding="1rem 0 0 0"
      flex="1 40%"
      flexgrow="0"
    >
      <H2 color={color}>{Heading}</H2>
      {Preamble && (
        <RTEWrapper
          color={color}
          maxWidth="530px"
          margin="1rem 0"
          dangerouslySetInnerHTML={{
            __html: Preamble,
          }}
        ></RTEWrapper>
      )}
      {Link != undefined && (
        <HeaderLink
          inverted
          width="fit-content"
          margin="2rem 0"
          target={Link.Target}
          href={Link.Url}
          text={Link.Name}
          ariaLabel={Link.Name}
          color={color}
        />
      )}
    </PagePuffWrapper>
  );
};
